import { mergeSx } from 'design-system';
import NumberFieldComponent from '../../NumberField';
import { UnsavedAdornment } from '../UnsavedIcon';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function NumberField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  isUnsaved,
  autoFocus,
  onChange,
}: FieldRendererProps) {
  return (
    <NumberFieldComponent
      className={className}
      sx={mergeSx(getFieldControlSx(hasWhiteFields, sx), { minWidth: '90px' })}
      slotProps={{
        htmlInput: { readOnly: isReadOnly },
        input: { endAdornment: isUnsaved ? <UnsavedAdornment /> : undefined },
      }}
      disabled={isDisabled}
      margin="dense"
      autoFocus={autoFocus}
      fullWidth
      id={field.id.toString()}
      label={field.label}
      required={field.required}
      value={field.value}
      onChange={(_, value) => onChange(value || '')}
    />
  );
}
